export default "__VITE_ASSET__CMXWnWjF__"